import { FC } from 'react';
import { PARTIAL_ACATS_BASE_PATH } from 'modules/Transfer/helper';
import withTransferForm, { PageIdEnum, TransferFormProps } from 'modules/Transfer/withTransferForm';
import CheckComp from '../../components/Check';
import { CheckPageFormutil } from '../../type';

const Check: FC<TransferFormProps<CheckPageFormutil>> = props => {
    const { onSubmit, setStorageDataByKey, getStorageDataByKey, goNextPath, $formutil } = props;
    const editBrokerData = getStorageDataByKey(PageIdEnum.EDIT_BROKER);
    const handleSubmit = () => {
        onSubmit(() => {
            // 需要使用编辑页面的缓存数据 替换到 对应的新增流程中的数据
            setStorageDataByKey(PageIdEnum.BROKER, editBrokerData);
            setStorageDataByKey(PageIdEnum.CHECK, $formutil.$params);

            goNextPath('../../preview');
        });
    };

    return <CheckComp onCheckSubmit={handleSubmit} brokerPageId={PageIdEnum.EDIT_BROKER} {...props} />;
};

export default withTransferForm({
    id: PageIdEnum.EDIT_CHECK,
    basePath: PARTIAL_ACATS_BASE_PATH,
    ensure: PageIdEnum.EDIT_BROKER,
    showProgressBar: false
})(Check);
